import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgActivity = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.875 10C1.875 9.65482 2.15482 9.375 2.5 9.375H4.54953L6.90707 2.30236C6.99214 2.04715 7.23098 1.875 7.5 1.875C7.76902 1.875 8.00786 2.04715 8.09293 2.30236L12.5 15.5236L14.4071 9.80236C14.4921 9.54714 14.731 9.375 15 9.375H17.5C17.8452 9.375 18.125 9.65482 18.125 10C18.125 10.3452 17.8452 10.625 17.5 10.625H15.4505L13.0929 17.6976C13.0079 17.9529 12.769 18.125 12.5 18.125C12.231 18.125 11.9921 17.9529 11.9071 17.6976L7.5 4.47642L5.59293 10.1976C5.50786 10.4529 5.26902 10.625 5 10.625H2.5C2.15482 10.625 1.875 10.3452 1.875 10Z",
		fill: "#FFF"
	})
});
export default SvgActivity;
